/* eslint-disable no-case-declarations */
/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  REPORT_QUESTION_TYPE_GET,
  REPORT_QUESTION_TYPE_POST,
} from '../constants/action-types'
import { ReportQuestion } from '../Actions'
import { persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import { ActionTypes } from '../action'

const initialState = {
  isLoading: false,
  errorMessage: '',
  reportQuestionList: [],
}

const reducer = persistReducer(
  { storage, key: 'report-question', whitelist: ['reportQuestionList'] },
  (state: ReportQuestion = initialState, action: ActionTypes) => {
    switch (action.type) {
      // ============= GET_REPORT_QUESTION ==============
      case REPORT_QUESTION_TYPE_GET.REPORT_QUESTION_TYPE_GET_INITIALIZATION:
        return {
          ...state,
          ...action.payload,
          errorMessage: '',
          isLoading: true,
        }
      case REPORT_QUESTION_TYPE_GET.REPORT_QUESTION_TYPE_GET_SUCCESS:
        return {
          ...state,
          ...action.payload,
          errorMessage: '',
          isLoading: false,
          reportQuestionList: action.payload,
        }

      case REPORT_QUESTION_TYPE_GET.REPORT_QUESTION_TYPE_GET_ERROR:
        return {
          ...state,
          ...action.payload,
          errorMessage: action.payload,
          isLoading: false,
        }
      // ============= POST_REPORT_QUESTION ==============
      case REPORT_QUESTION_TYPE_POST.REPORT_QUESTION_TYPE_POST_INITIALIZATION:
        return {
          ...state,
          ...action.payload,
          errorMessage: '',
          isLoading: true,
        }
      case REPORT_QUESTION_TYPE_POST.REPORT_QUESTION_TYPE_POST_SUCCESS:
        return {
          ...state,
          ...action.payload,
          errorMessage: '',
          isLoading: false,
        }

      case REPORT_QUESTION_TYPE_POST.REPORT_QUESTION_TYPE_POST_ERROR:
        return {
          ...state,
          ...action.payload,
          errorMessage: action.payload,
          isLoading: false,
        }
      default:
        return state
    }
  }
)

export default reducer
